'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _format2 = require('../../helpers/format');

var _format3 = _interopRequireDefault(_format2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { Link, LinkIcon } from '../'

var EsgConfig = {
  esgNamesLabels: [{
    label: 'Overall gender equality score',
    value: 'gef_score_norm'
  }, {
    label: 'Gender balance in leadership and workforce',
    value: 'gef_score_a'
  }, {
    label: 'Equal compensation and work life balance',
    value: 'gef_score_b'
  }, {
    label: 'Policies promoting gender equality',
    value: 'gef_score_c'
  }, {
    label: 'Commitment, transparency, and accountability',
    value: 'gef_score_d'
  }],
  esgOptions: {
    gef_score_norm: {
      id: 'gef_score_norm',
      icon: 'icons_step2',
      fieldLabel: 'gef_score_norm',
      benchLabel: 'gef_score_norm',
      valueLabel: 'Overall gender equality score',
      direction: 'descending',
      page: 'gender-equality-score',
      label: 'overall gender equality score',
      units: function units(diff) {
        return ' / 100 points';
      },
      unitsExpanded: function unitsExpanded(diff) {
        return ' / 100 points';
      },
      diffGood: function diffGood(diff) {
        return diff > 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-good' : 'lower-bad';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'Higher' : 'Lower';
      },
      format: function format(val) {
        return _format3.default.number(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (_format3.default.roundsToZero(val)) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same '
            ),
            ' gender equality overall score'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          'an overall gender equality score ',
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            moreLess,
            ' by ',
            _format3.default.number(val),
            ' ',
            _format3.default.maybePluralize(_format3.default.number(val), 'point'),
            ' out of 100'
          )
        );
      }
    },
    gef_score_a: {
      id: 'gef_score_a',
      icon: 'icons_step3',
      fieldLabel: 'gef_score_a',
      benchLabel: 'gef_score_a',
      valueLabel: 'Gender balance in leadership and workforce',
      direction: 'descending',
      page: 'gender-equality-subscore-a',
      label: 'gender balance in leadership and workforce score',
      units: function units(diff) {
        return ' / 40 points';
      },
      unitsExpanded: function unitsExpanded(diff) {
        return ' / 40 points';
      },
      diffGood: function diffGood(diff) {
        return diff > 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-good' : 'lower-bad';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'Higher' : 'Lower';
      },
      format: function format(val) {
        return _format3.default.number(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (_format3.default.roundsToZero(val)) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same '
            ),
            ' subscoreA score'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          'a subscoreA score ',
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            moreLess,
            ' by ',
            _format3.default.number(val),
            ' ',
            _format3.default.maybePluralize(_format3.default.number(val), 'point'),
            ' out of 40'
          )
        );
      }
    },
    gef_score_b: {
      id: 'gef_score_b',
      icon: 'icons_step4',
      fieldLabel: 'gef_score_b',
      benchLabel: 'gef_score_b',
      valueLabel: 'Equal compensation and work life balance',
      direction: 'descending',
      page: 'gender-equality-subscore-b',
      label: 'equal compensation and work life balance score',
      units: function units(diff) {
        return ' / 30 points';
      },
      unitsExpanded: function unitsExpanded(diff) {
        return ' / 30 points';
      },
      diffGood: function diffGood(diff) {
        return diff > 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-good' : 'lower-bad';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'Higher' : 'Lower';
      },
      format: function format(val) {
        return _format3.default.number(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (_format3.default.roundsToZero(val)) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same '
            ),
            ' subscoreB score'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          'a subscoreB score ',
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            moreLess,
            ' by ',
            _format3.default.number(val),
            ' ',
            _format3.default.maybePluralize(_format3.default.number(val), 'point'),
            ' out of 30'
          )
        );
      }
    },
    gef_score_c: {
      id: 'gef_score_c',
      icon: 'icons_step4',
      fieldLabel: 'gef_score_c',
      benchLabel: 'gef_score_c',
      valueLabel: 'Policies promoting gender equality',
      direction: 'descending',
      page: 'gender-equality-subscore-c',
      label: 'policies promoting gender equality score',
      units: function units(diff) {
        return ' / 20 points';
      },
      unitsExpanded: function unitsExpanded(diff) {
        return ' / 20 points';
      },
      diffGood: function diffGood(diff) {
        return diff > 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-good' : 'lower-bad';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'Higher' : 'Lower';
      },
      format: function format(val) {
        return _format3.default.number(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (_format3.default.roundsToZero(val)) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same '
            ),
            ' subscoreC score'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          'a subscoreC score ',
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            moreLess,
            ' by ',
            _format3.default.number(val),
            ' ',
            _format3.default.maybePluralize(_format3.default.number(val), 'point'),
            ' out of 20'
          )
        );
      }
    },
    gef_score_d: {
      id: 'gef_score_d',
      icon: 'icons_step4',
      fieldLabel: 'gef_score_d',
      benchLabel: 'gef_score_d',
      valueLabel: 'Commitment, transparency, and accountability',
      direction: 'descending',
      page: 'gender-equality-subscore-d',
      label: 'commitment, transparency, and accountability score',
      units: function units(diff) {
        return ' / 10 points';
      },
      unitsExpanded: function unitsExpanded(diff) {
        return ' / 10 points';
      },
      diffGood: function diffGood(diff) {
        return diff > 0;
      },
      diffStyle: function diffStyle(diff) {
        return diff > 0 ? 'higher-good' : 'lower-bad';
      },
      moreLess: function moreLess(diff) {
        return diff > 0 ? 'Higher' : 'Lower';
      },
      format: function format(val) {
        return _format3.default.number(val);
      },
      formatExpanded: function formatExpanded(val, moreLess, postiveNegative, url) {
        if (_format3.default.roundsToZero(val)) {
          return _react2.default.createElement(
            'span',
            null,
            _react2.default.createElement(
              'strong',
              null,
              'the same '
            ),
            ' subscoreD score'
          );
        }
        return _react2.default.createElement(
          'span',
          null,
          'a subscoreD score ',
          _react2.default.createElement(
            'strong',
            { styleName: postiveNegative },
            moreLess,
            ' by ',
            _format3.default.number(val),
            ' ',
            _format3.default.maybePluralize(_format3.default.number(val), 'point'),
            ' out of 10'
          )
        );
      }
    }
  }
};
// import config from '../../config'
exports.default = EsgConfig;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/EsgConfig/EsgConfig.js
// module id = 1292
// module chunks = 0